import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { AutoCompleteGenericMultiple } from "src/Pages/components/InputAutoCompleted/AutoCompleteGenericMultiple";
import { IPropsAutoCompleted } from "src/Pages/components/InputAutoCompleted/types";

export const SelectedAdministradorasGeneric = (props: IPropsAutoCompleted) => {
  const {
    label,
    width,
    tamanho,
    minWidth,
    maxWidth,
    fullWidth,
    disabled,
    variant,
  } = props;

  const { valueAutoCompAdministradoras, setValueAutoCompAdministradoras } =
    useContextReportsProduction();

  return (
    <AutoCompleteGenericMultiple
      openInClick
      disabled={disabled}
      fullWidth={fullWidth}
      label={label}
      maxWidth={maxWidth}
      minWidth={minWidth}
      setValueAutoCompleted={setValueAutoCompAdministradoras}
      tamanho={tamanho}
      url="/comissoes/administradorasListAll"
      valueAutoCompleted={valueAutoCompAdministradoras}
      variant={variant}
      width={width}
    />
  );
};
